import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "w-full h-full object-cover rounded relative" };
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 0,
    class: "glass-effect absolute bottom-0 w-full text-white flex items-center justify-between p-2"
};
const _hoisted_4 = { class: "font-semibold mr-2" };
const _hoisted_5 = { class: "flex items-center justify-center bg-gray-200 w-full h-full object-cover rounded" };
import { CheckSquareBrokenIcon } from '@gohighlevel/ghl-icons/24/outline';
import { UISpin } from '@gohighlevel/ghl-ui';
import { ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIImagePreview',
    props: {
        imageSrc: {
            type: String,
            default: '',
        },
        width: {
            type: String,
            default: '20px',
        },
        height: {
            type: String,
            default: '20x',
        },
        borderWidth: {
            type: String,
            default: '8px',
        },
        spinnerClass: {
            type: String,
            default: 'w-4 h-4',
        },
        selected: {
            type: Boolean,
            default: false,
        },
        variationTag: {
            type: String,
            default: '',
        },
        tailwindBorderClass: {
            type: String,
            default: 'bg-white',
        },
    },
    emits: ['saveImage'],
    setup(__props) {
        const props = __props;
        const customStyle = ref({
            width: props.width,
            height: props.height,
            padding: props.borderWidth,
        });
        const isLoading = ref(true);
        function handleLoad() {
            isLoading.value = false;
        }
        function handleError() {
            if (props.imageSrc) {
                isLoading.value = false;
            }
        }
        watch(() => props.imageSrc, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                isLoading.value = true;
            }
        }, { immediate: true });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(`${isLoading.value ? 'bg-gray-200' : __props.tailwindBorderClass} border rounded relative`),
                style: _normalizeStyle(customStyle.value)
            }, [
                _withDirectives(_createElementVNode("div", _hoisted_1, [
                    _createElementVNode("img", {
                        src: __props.imageSrc,
                        alt: "image_preview",
                        onLoad: handleLoad,
                        onError: handleError
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2),
                    (__props.variationTag)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("p", _hoisted_4, _toDisplayString(__props.variationTag), 1 /* TEXT */),
                            (__props.selected)
                                ? (_openBlock(), _createBlock(_unref(CheckSquareBrokenIcon), {
                                    key: 0,
                                    class: "w-4 h-4"
                                }))
                                : _createCommentVNode("v-if", true)
                        ]))
                        : _createCommentVNode("v-if", true)
                ], 512 /* NEED_PATCH */), [
                    [_vShow, !isLoading.value]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_5, [
                    _createVNode(_unref(UISpin), {
                        class: _normalizeClass(__props.spinnerClass)
                    }, null, 8 /* PROPS */, ["class"])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, isLoading.value]
                ])
            ], 6 /* CLASS, STYLE */));
        };
    }
});
